/** Tipos: 0 Coordenador | 1 Administrador | 2 Gerente Técnico | 3 Técnico | 4 Financeiro */

export function parseUserType(user) {
  const t = user?.type;
  if (t === 0 || t === '0') return 0;
  if (t === 1 || t === '1' || t === 'Administrador') return 1;
  if (t === 2 || t === '2' || t === 'Gerente Técnico') return 2;
  if (t === 3 || t === '3' || t === 'Técnico') return 3;
  if (t === 4 || t === '4' || t === 'Financeiro' || Number(t) === 4) return 4;
  if (t === 'Usuário' || t === 'Coordenador' || t === 'usuário') return 0;
  const n = parseInt(String(t ?? ''), 10);
  return Number.isNaN(n) ? null : n;
}

export function isGerenteTecnico(user) {
  return parseUserType(user) === 2;
}

export function isAdminUserType(user) {
  return parseUserType(user) === 1;
}

export function isCoordenadorUser(user) {
  const type = parseUserType(user);
  if (type === 0) return true;
  return user?.coordinator === true || user?.coordinator === 1;
}

export function hasCreateReportsPermission(user) {
  return user?.asstec_create_reports === 1 || user?.asstec_create_reports === true;
}

/** Cliente com módulo Customers habilitado (verve_customers_module) */
export function hasCustomersModuleAccess(user) {
  return Number(user?.verve_customers_module) === 1;
}

/** Administrador ou Gerente Técnico — menu Análises completo */
export function canAccessFullAnalisesMenu(user) {
  if (!user) return false;
  const type = parseUserType(user);
  return type === 1 || type === 2;
}

/** Experiência do cliente — perfil Análises + módulo Customers do cliente */
export function canAccessExperienciaClienteModule(user) {
  return canAccessFullAnalisesMenu(user) && hasCustomersModuleAccess(user);
}

/** Coordenador (não gerente técnico) com permissão Criar relatórios */
export function canAccessRelatoriosAsCoordenador(user) {
  if (!user || !hasCreateReportsPermission(user)) return false;
  if (isGerenteTecnico(user) || isAdminUserType(user)) return false;
  return isCoordenadorUser(user);
}

export function canShowAnalisesNav(user) {
  return canAccessFullAnalisesMenu(user) || canAccessRelatoriosAsCoordenador(user);
}

export function canAccessRelatoriosModule(user) {
  if (!user) return false;
  if (canAccessFullAnalisesMenu(user)) return true;
  return canAccessRelatoriosAsCoordenador(user);
}
